import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";


@Injectable()
export class MiscService {
	/**
	 * @param {HttpClient} http_client
	 */
	constructor(private http_client: HttpClient) {
	}

	/**
	 * @param {string} url_endpoint
	 * @return {Observable<object>}
	 */
	getPreviewLink(url_endpoint: string, body: any): Observable<object> {
		return this.http_client.post(url_endpoint, {})
			.pipe(
				map((response: Observable<object>) => response)
			);
	}
}
